/**
 * Custom handler for submitting the closest form for a link after allowing
 * default browser behavior to navigate to the href. This will allow a file
 * path to get opened and simultaneously act like a form submit.
 */

export default class SharedFileOpener {
  constructor(selector) {
    this.selector = selector || '.js-shared-file-opener';
  }

  attach() {
    N2.bindHandler('click', this.selector, function(evt) {
       // Wrap in setTimeout so default browser behavior allows opening the
       // link before we submit the form to cause the page navigation.
      setTimeout(() => {
        $(this).closest('form').submit();
      }, 0)
    });
  }
}
